module.exports = __webpack_public_path__ + "img/6600.dcb4ef4a.jpg";